export default __webpack_public_path__ + "static/media/thumbnail.c8b2d97b.png";